"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationRuleMessage = exports.validationRuleCity = exports.validationRulePostalcode = exports.validationRuleHousenumber = exports.validationRuleStreet = exports.validationRuleLastName = exports.validationRuleFirstName = void 0;
var ruleSpecCharacters = {
    regEx: /^[A-Za-z.\-ßÄÖÜäöü ]*$/,
    error: {
        id: 'form.error.no.special.characters',
    },
};
var ruleSpecCharactersV2 = {
    regEx: /^[A-Za-z0-9.\-ßÄÖÜäöü ]*$/,
    error: {
        id: 'form.error.no.special.characters.v2',
    },
};
exports.validationRuleFirstName = [
    {
        required: true,
        error: {
            id: 'form.type.firstname.error',
        },
    },
    ruleSpecCharacters,
];
exports.validationRuleLastName = [
    {
        required: true,
        error: {
            id: 'form.type.lastname.error',
        },
    },
    ruleSpecCharacters,
];
exports.validationRuleStreet = [
    {
        required: true,
        error: {
            id: 'form.type.street.error',
        },
    },
    ruleSpecCharacters,
];
exports.validationRuleHousenumber = [
    {
        required: true,
        error: {
            id: 'form.type.housenumber.error',
        },
    },
    ruleSpecCharactersV2,
];
exports.validationRulePostalcode = [
    {
        required: true,
        error: {
            id: 'form.type.postalcode.error',
        },
    },
    ruleSpecCharactersV2,
];
exports.validationRuleCity = [
    {
        required: true,
        error: {
            id: 'form.type.city.error',
        },
    },
    ruleSpecCharacters,
];
exports.validationRuleMessage = [
    {
        required: true,
        error: {
            id: 'form.type.message.error',
        },
    },
];
//# sourceMappingURL=validationRules.js.map